import { styled } from '@mui/material';

export const Form = styled('form')(({ theme }) => ({
  maxWidth: theme.breakpoints.values.xl,
  paddingBottom: theme.spacing(10),
  paddingTop: theme.spacing(2),

  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),

  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },

  [theme.breakpoints.up('xl')]: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },

  [theme.breakpoints.up('xxl')]: {
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
  },
}));
